import React, { FC } from 'react';
import * as yup from 'yup';
import { validateNativeRut } from 'global/utils/validation';
import logo from 'assets/logo.png';
import { FormikInput } from 'common/form';
import { Formik, Form } from 'formik';
import { SendButton } from 'pages/user/components';
import { useSignInState, useUpdateSignInState } from 'state/index';
import { RutFormProps } from './rut-form.types';

import styles from './rut-form.module.scss';

export const RutForm: FC<RutFormProps> = ({
  isLoading,
  onSignUp,
  remoteValidationError,
  resetRemoteValidatorError,
}) => {
  const { username } = useSignInState();
  const { backToSignIn } = useUpdateSignInState();
  return (
    <Formik
      initialValues={{ rut: '' }}
      validationSchema={yup.object().shape({ rut: validateNativeRut })}
      onSubmit={values => onSignUp(values.rut)}>
      <div className={styles.formContainer}>
        <img alt="logo" src={logo} />
        <h2 className="mt-3">Registrar usuario</h2>
        <span className="px-4 mt-3">Introduzca su número de RUT</span>
        <span className="px-4">para crear el usuario</span>
        <span>
          <b>{username}</b>.
        </span>

        <Form className="w-full mt-4">
          <FormikInput
            name="rut"
            suffix={<SendButton isLoading={isLoading} />}
            wrapperClassName="w-full"
            onBlur={() => resetRemoteValidatorError?.()}
          />
          {remoteValidationError && <p className="text-sm text-red-600 text-left">{remoteValidationError}</p>}
        </Form>
        <span className="px-4 mt-3">¿Se ha equivocado?</span>
        <span className="px-4 underline cursor-pointer" onClick={backToSignIn}>
          Vuelva a ingresar su correo electrónico
        </span>
      </div>
    </Formik>
  );
};
